import { NgStyle } from '@angular/common';
import {
  Component,
  Input,
  ChangeDetectionStrategy,
  AfterViewInit,
  OnDestroy,
  ElementRef,
  Output,
  EventEmitter,
  OnChanges,
  numberAttribute,
  input,
  viewChild,
  InputSignal,
  Signal
} from '@angular/core';

import { StickyService } from '../sticky.service';

@Component({
  selector: 'td-wb-sticky-observer',
  templateUrl: 'sticky-observer.component.html',
  styleUrls: ['sticky-observer.component.scss'],
  imports: [
    NgStyle
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StickyObserverComponent implements OnChanges, AfterViewInit, OnDestroy  {
  /* eslint-disable lines-between-class-members */
  @Input()
  get offset(): number { return this._offset; }
  set offset(value: number) {
    this._offset = numberAttribute(value, 0);
  }
  /* eslint-enable lines-between-class-members */

  readonly bottom: InputSignal<boolean> = input<boolean>(false);

  @Output() readonly stateChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  readonly stickyPanel: Signal<ElementRef | undefined> = viewChild<ElementRef>('stickyPanel');

  private stuck: boolean;
  private observer: IntersectionObserver;
  private _offset: number = 0;
  private totalOffset: number = 0;
  private readonly pageOffset: number;

  constructor(stickyService: StickyService) {
    this.pageOffset = stickyService.getPageOffset();
  }

  ngOnChanges(): void {
    this.setTotalOffset();
  }

  ngAfterViewInit(): void {
    this.setIntersectionObserver();
  }

  ngOnDestroy(): void {
    if (this.observer !== undefined) {
      this.observer.disconnect();
    }
  }

  getTop(): string {
    return `${ this.totalOffset }px`;
  }

  private setIntersectionObserver(): void {
    this.observer = new IntersectionObserver((entries: Array<IntersectionObserverEntry>): void => {
      const stuck = entries[0].intersectionRatio !== 1;
      if (this.stuck !== stuck) {
        this.stuck = stuck;
        this.stateChange.emit(this.stuck);
      }
    }, { threshold: 1 } );
    this.observer.observe(this.stickyPanel().nativeElement);
  }

  private setTotalOffset(): void {
    if (this.bottom()) {
      this.totalOffset = this.offset;
    } else {
      this.totalOffset = -(this.pageOffset + this.offset);
    }
  }
}
